export default __webpack_public_path__ + "images/0f3ac442a4fb3e9efba25a3d09a3efcf.png";